import { render, staticRenderFns } from "./CreateInstagramChannel.vue?vue&type=template&id=10b24cb3&scoped=true"
import script from "./CreateInstagramChannel.vue?vue&type=script&lang=js"
export * from "./CreateInstagramChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateInstagramChannel.vue?vue&type=style&index=0&id=10b24cb3&prod&lang=scss&scoped=true"
import style1 from "./CreateInstagramChannel.vue?vue&type=style&index=1&id=10b24cb3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b24cb3",
  null
  
)

export default component.exports